module.exports = __webpack_public_path__ + "static/img/anger3.3a1e8f1d.png";